import { useState } from 'react'

/**
 * Custom hook that manages the state of a modal.
 *
 * @param {boolean} state - The initial state of the modal.
 * @returns {[boolean, function]} - An array containing the state value and a function to toggle the modal state.
 */
export const useModal = (state = false) => {
  const [show, setShow] = useState(state)

  const toggleModal = (modalName) => {
    if (typeof show === 'boolean') {
      setShow(!show)
    } else {
      setShow(modalName)
    }
  }

  return [show, toggleModal]
}
